import { createActions } from 'reduxsauce';
import { IPageType, RecipientDetailSection } from 'store/donatePage/types';

export interface PagesState {
  data: PagesData;
  fullListData: PagesData;
  isLoading: boolean;
  error: string;
}

export type PagesData = {
  pages: IPageBase[];
};

export type IPageBase = {
  id: number;
  value: string;
  query_str: string;
  client_id?: number;
  donation_amounts: number[];
  is_enabled: boolean;
  page_category?: string;
  status?: string;
  updated_date?: string;
  event_id?: string;
  page_type: IPageType;
  custom_disclaimer?: string;
  has_image?: boolean;
  has_community_image?: boolean;
  image_filenames?: {
    [key: string]: string;
  };
  page_background?: string;
  page_color_text?: string;
  recipient_details?: {
    [key: string]: {
      header_1?: string;
      header_2?: string;
      summary?: string;
      sections?: RecipientDetailSection[];
    };
  };
  recipient_order_by?: string;
  subtitle?: string;
  wire_enabled?: boolean;
};

export interface PagesTypes {
  PAGES: 'PAGES';
  PAGES_START: 'PAGES_START';
  PAGES_SUCCESS: 'PAGES_SUCCESS';
  PAGES_ERROR: 'PAGES_ERROR';
  PAGES_CLEAN_UP: 'PAGES_CLEAN_UP';
}

const { Types, Creators } = createActions<PagesTypes>({
  pages: ['data'],
  pagesStart: null,
  pagesSuccess: ['data'],
  pagesError: ['error'],
  pagesCleanUp: null,
});

export { Types };

export default Creators;
